export const AI_SUMMARY_REVIEW_COUNT_THRESHOLD = 1000
export const AI_SUMMARY_TAGS_DISPLAY_LIMIT = 6
export const AI_SUMMARY_TAGS_MOBILE_COLLAPSED_LIMIT = 3
